// No need to import React in modern React setups

const CheckIcon = () => (
  <svg
    fill="none"
    height="15"
    viewBox="0 0 15 15"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4281_209)">
      <path
        d="M7.5 0.625C6.14026 0.625 4.81105 1.02821 3.68046 1.78365C2.54987 2.53908 1.66868 3.61281 1.14833 4.86905C0.627979 6.12529 0.491831 7.50763 0.757104 8.84125C1.02238 10.1749 1.67716 11.3999 2.63864 12.3614C3.60013 13.3228 4.82514 13.9776 6.15876 14.2429C7.49238 14.5082 8.87471 14.372 10.131 13.8517C11.3872 13.3313 12.4609 12.4501 13.2164 11.3195C13.9718 10.189 14.375 8.85975 14.375 7.5C14.375 5.67664 13.6507 3.92795 12.3614 2.63864C11.0721 1.34933 9.32337 0.625 7.5 0.625ZM11.0669 6.06687L6.69188 10.4419C6.57467 10.559 6.41573 10.6249 6.25 10.6249C6.08427 10.6249 5.92533 10.559 5.80813 10.4419L3.93313 8.56687C3.81928 8.449 3.75628 8.29112 3.75771 8.12725C3.75913 7.96338 3.82486 7.80662 3.94074 7.69074C4.05662 7.57486 4.21338 7.50913 4.37725 7.5077C4.54112 7.50628 4.699 7.56928 4.81688 7.68313L6.25 9.11625L10.1831 5.18313C10.301 5.06928 10.4589 5.00628 10.6228 5.0077C10.7866 5.00913 10.9434 5.07486 11.0593 5.19074C11.1751 5.30662 11.2409 5.46338 11.2423 5.62725C11.2437 5.79112 11.1807 5.949 11.0669 6.06687Z"
        fill="#007AFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_4281_209">
        <rect fill="white" height="15" width="15" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckIcon;
